import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useDisciplineStore } from '@stores/discipline'

import { useDisciplineTaskCommentsApi } from '@api/discipline-task-comments/comments.hook'
import { useDisciplineContext } from '@hooks/discipline/discipline-context.hook'
import { parseFilterParams } from '@hooks/discipline-task-comments/filter-params'

import { defineNuxtRouteMiddleware } from '#app'

/** The comments are the customer's, so they are read once the shared discipline read knows the customer;
 *  the navigation never waits for either. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const disciplineId = to.params.id

  if (typeof disciplineId !== 'string' || !disciplineId) return

  const filters = parseFilterParams(to.query)

  void useDisciplineContext().whenReady(disciplineId).then(() => {
    const customerId = useDisciplineStore().getCustomerId
    if (!customerId) return

    void useDisciplineTaskCommentsApi({
      customerId,
      disciplineId: filters.discipline_id.length ? filters.discipline_id : [],
      createdFrom: filters.created_from,
      createdTo: filters.created_to,
    })
  })
})
